import { _User } from "../parsegenerated";

/**
 * Get the proper username with fallbacks
 * @param user
 */
export function getUsername(user: _User): string {
  if (!user) return "";

  return user.get("name") || user.getUsername() || user.getEmail() || "";
}
